<template>
    <div>
        <FastDeliveryModal v-if="isMoscowRegion" />
    </div>
</template>

<script setup>
    import { onMounted } from 'vue';
    import { useDelivery } from './composables/useDelivery.ts';
    import FastDeliveryModal from './fast-delivery-modal/App.vue';
    import * as deliveryService from 'desktopeModules/checkout/order/api/deliveryService.js';
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';
    import 'tippy.js/themes/light.css';

    const {
        setList,
        initRegionDeliveryInCard,
        initMskDeliveryInCard,
        initDeliveryInCatalog,
        setProductCode,
    } = useDelivery();

    const isMoscowRegion = window.config?.user?.isHomeLocation;
    const isMobile = window.config?.state?.theme === 'mobile';

    /** @TODO отрефакторить, убрать карту ПВЗ  */
    onMounted(() => {
        initShopsList();
        initCatalog();
        initCard();

        tippy('.badge--delivery', {
            interactive: true,
            trigger: isMobile ? 'click' : 'mouseenter',
            content(reference) {
                return reference.dataset.title;
            },
            allowHTML: true,
            theme: 'light',
            placement: 'auto',
            appendTo: document.body,
        });
    });

    const initShopsList = () => {
        document
            .querySelectorAll('.show-all-shops a')
            .forEach(function (showAllShops) {
                showAllShops.addEventListener('click', function (e) {
                    e.preventDefault();

                    document
                        .querySelectorAll('.shops-list')
                        .forEach(function (shopsList) {
                            if (shopsList !== this.nextElementSibling) {
                                shopsList.style.display = 'none';
                            }
                        }, this);

                    const currentShopsList = this.nextElementSibling;
                    if (
                        currentShopsList.style.display === 'none' ||
                        currentShopsList.style.display === ''
                    ) {
                        currentShopsList.style.display = 'block';
                    } else {
                        currentShopsList.style.display = 'none';
                    }
                });
            });
    };

    const initCard = () => {
        const productButtonElement =
            document.querySelector('.price-offer .cart-add') ??
            document.querySelector('.product-offer .cart-add');

        if (!productButtonElement) {
            return;
        }

        const deliveryBlock = document.querySelector('.product-delivery-block');

        const productDeliveryServiceElement = document.querySelector(
            '.product-delivery-service a'
        );

        if (
            !window.config?.user?.hasLocation &&
            productDeliveryServiceElement
        ) {
            productDeliveryServiceElement.textContent = 'Выберите регион';
        }

        deliveryBlock.classList.add('loading');

        deliveryService
            .getDeliveryList({
                good_code: productButtonElement.dataset.id,
                main_good_code: productButtonElement.dataset.id,
                is_fast: 1,
            })
            .then(({ data }) => {
                if (!data.error) {
                    setList(data);
                    setProductCode(productButtonElement.dataset.id);
                    isMoscowRegion
                        ? initMskDeliveryInCard()
                        : initRegionDeliveryInCard();
                }
            })
            .finally(() => {
                deliveryBlock.classList.remove('loading');
            });
    };

    const initCatalog = () => {
        const productButtonElement =
            document.querySelector('.price-offer .cart-add') ??
            document.querySelector('.product-offer .cart-add');

        if (productButtonElement) {
            return;
        }

        if (!isMoscowRegion) {
            initDeliveryInCatalog();
        }
    };
</script>
